exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-group input {\n  padding-left: 5px !important;\n  padding-right: 5px !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /root/production/sne-pro/src/app/component/accounts/accounts/accounts.component.css
// module id = ../../../../../src/app/component/accounts/accounts/accounts.component.css
// module chunks = main